import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appRequired]'
})
export class RequiredDirective implements OnInit {
  @Input() appRequired = false;

  constructor(private el: ElementRef, private renderer: Renderer2) { }

  ngOnInit(): void {
    if (this.appRequired) {
      const span = this.renderer.createElement('span');
      this.renderer.addClass(span, 'text-danger');
      span.innerHTML = '*';
      this.renderer.appendChild(this.el.nativeElement, span);
    }
  }
}
